import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useGet } from "../../lib/hooks";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

function Question({ q }) {
  return (
    <div className="rounded-md border border-white/10 p-4" data-testid={`result-${q.key}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="text-sm font-medium">{q.label}</div>
        <div className="text-xs text-muted-foreground">{q.answered} answered{q.average != null && <span className="ml-2 text-[#EBD6A0]" data-testid={`result-avg-${q.key}`}>average {q.average}</span>}</div>
      </div>
      {q.counts ? (
        <div className="mt-3" style={{ height: Math.max(140, Math.min(q.counts.length, 11) * 26) }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={q.counts} layout="vertical" margin={{ left: 8, right: 24 }}>
              <XAxis type="number" allowDecimals={false} stroke="#64748b" fontSize={11} />
              <YAxis type="category" dataKey="name" width={140} stroke="#94a3b8" fontSize={11} />
              <Tooltip cursor={{ fill: "rgba(194,164,98,0.08)" }} contentStyle={{ background: "#0B1220", border: "1px solid rgba(194,164,98,0.3)", fontSize: 12 }} />
              <Bar dataKey="value" name="Responses" fill="#C2A462" radius={[0, 3, 3, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <ul className="mt-2 max-h-48 space-y-1 overflow-y-auto text-sm text-slate-300">
          {q.answers.map((a, i) => <li key={i} className="whitespace-pre-wrap border-b border-white/5 pb-1">{a}</li>)}
          {!q.answers.length && <li className="text-muted-foreground">No answers yet.</li>}
        </ul>
      )}
    </div>
  );
}

export function SurveyResults({ form, onClose }) {
  const [r] = useGet(`/forms/${form.id}/results`);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="survey-results-dialog">
        <DialogHeader><DialogTitle>{form.name} · results</DialogTitle>
          <DialogDescription data-testid="survey-results-total">{r ? `${r.total} response${r.total === 1 ? "" : "s"}${form.anonymous ? " · anonymous" : ""}` : "Loading…"}</DialogDescription></DialogHeader>
        <div className="space-y-3">{(r?.questions || []).map((q) => <Question key={q.key} q={q} />)}</div>
      </DialogContent>
    </Dialog>
  );
}
